import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { CartAndProfileModel } from 'app/model/checkout/cart-profile.model';
import { Checkout3Config, Paymentable, PaymentChannelCheckout, PaymentChannelItem } from 'app/model/checkout/checkout3-config.model';
import { PaymentChannelType, PurposeType } from 'app/model/constant';
import { FleetCardInformationResponse } from 'app/model/fleet/fleet.model';
import { Checkout3Service } from 'app/pages/checkout-module/checkout3/services/checkout3.service';
import { AuthorizeService } from 'app/services/authorize/authorize.service';
import { CartService } from 'app/services/cart/cart.service';
import { UtilitiesService } from 'app/services/utilities/utilities.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'act-payment-method',
  templateUrl: './payment-method.component.html',
  styleUrls: ['./payment-method.component.scss']
})
export class PaymentMethodComponent implements OnInit, OnDestroy {

  @Input() name: string;
  @Input() checkout3Config: Checkout3Config;
  @Input() purpose: string;
  @Input() cartProfile: CartAndProfileModel;
  @Input() fleetCardListCorporate: FleetCardInformationResponse[];
  @Input() fleetCardListPersonal: FleetCardInformationResponse[];
  @Input() set isMultipaymentBookForTraveller(isMultipaymentBookForTraveller) {
    if (isMultipaymentBookForTraveller) {
      this.paymentMethodForBookForTraveller();
    } else {
      this.handlePaymentMethod();
    }
  }

  @Output() selectPaymentChannel: EventEmitter<string> = new EventEmitter();
  @Output() isOverBudget: EventEmitter<boolean> = new EventEmitter();

  public paymentChannelType = PaymentChannelType;
  public paymentable: Paymentable;
  public paymentChannelSelected: PaymentChannelItem;
  public collapse = true;
  public isMobile = false;

  private isShareBudget: boolean;
  private cartBudgetAvailableSubscription: Subscription;

  constructor(
    private checkout3Service: Checkout3Service,
    private utilitiesService: UtilitiesService,
    private authorizeService: AuthorizeService,
    private cartService: CartService,
  ) { }

  ngOnInit() {
    this.isMobile = this.utilitiesService.isMobile();
    this.isShareBudget = !!this.authorizeService.getCoBookerCookie() && this.purpose === PurposeType.work;
  }

  ngOnDestroy() {
    this.cartBudgetAvailableSubscription && this.cartBudgetAvailableSubscription.unsubscribe();
  }

  handlePaymentMethod() {
    if (this.cartService.verifyShouldCheckBudgetAvailable(this.purpose)) {
      this.cartBudgetAvailableSubscription && this.cartBudgetAvailableSubscription.unsubscribe();
      this.cartBudgetAvailableSubscription = this.cartService.getCartBudgetAvailable().subscribe(res => {
        if (res) {
          this.paymentMethod();
        }
      });
    } else {
      this.paymentMethod();
    }
  }

  onSelectPaymentChannel(paymentChannel: PaymentChannelItem) {
    this.paymentChannelSelected = paymentChannel;
    if (this.isMobile) {
      this.collapse = true;
    }
    this.selectPaymentChannel.emit(paymentChannel.paymentChannelName);
  }

  paymentMethod() {
    this.paymentable = this.checkout3Service.getPayableMethod(
      this.checkout3Config,
      this.purpose,
      this.cartProfile,
      this.fleetCardListCorporate,
      this.fleetCardListPersonal,
      this.isShareBudget);

    this.paymentChannelSelected = this.paymentable.paymentChannels.find(item => item.default);
    this.selectPaymentChannel.emit(this.paymentChannelSelected.paymentChannelName);
    this.isOverBudget.emit(this.paymentable.isOverBudget);
  }

  paymentMethodForBookForTraveller() {
    const payableMethod = new PaymentChannelCheckout();
    payableMethod.MULTI_PAYMENT.hide = false;
    payableMethod.CREDIT_TERMS.hide = true;
    payableMethod.CREDIT_CARD.hide = false;
    payableMethod.TRUE_MONEY_WALLET.hide = false;
    payableMethod.FLEET_CARD.hide = false;
    payableMethod.MULTI_PAYMENT.default = true;
    payableMethod.QR_CODE.hide = false;
    payableMethod.E_WALLET.hide = false;
    payableMethod.IM_BANKING.hide = false;
    payableMethod.PAY_AT_COUNTER.hide = false;

    this.paymentable.paymentChannels = payableMethod.getPaymentable().paymentChannels.filter(item => !item.hide);
    this.paymentable.mainBookerEmail = this.cartProfile.profile.email.valueOf();
    this.paymentable.isOverBudget = true;

    this.paymentChannelSelected = this.paymentable.paymentChannels.find(item => item.default);
    this.selectPaymentChannel.emit(this.paymentChannelSelected.paymentChannelName);
    this.isOverBudget.emit(this.paymentable.isOverBudget);
  }

}



// WEBPACK FOOTER //
// ./src/app/components/payment-method/payment-method.component.ts